import React from 'react'
import {Dialog, Grid} from '@material-ui/core'

export default React.memo(props => {

  const b = React.cloneElement(props.children, {
    ...props.children.props,
    fromModal: true,
    title:
      <Grid
        container
        style={{ margin: 0, padding: 0 }}
        spacing={0}
        justify={'flex-start'}
        alignItems={'center'}>
        <Grid item style={{ margin: 0, padding: 0 }}>
                              <span
                                style={{
                                  wordWrap: 'break-word',
                                  width: '100%',
                                  whiteSpace: 'initial',
                                  fontWeight: 'normal',
                                  //textAlign: 'center'
                                }}>
                                {props.children && props.children.props && props.children.props.title || ''}
                              </span>
        </Grid>
      </Grid>
  })

  const body = <Grid container spacing={0} style={{
    margin: 0,
    padding: 0,
    width: (((props.grid && props.grid.xs || 6) / 12) !== 1) && 'calc(100vw * ' + (props.grid && props.grid.xs || 6) + ' / 12 ' || '100%',
    background: 'transparent'
  }} justify="center" alignItems="center" alignContent={'center'}>
    {b}
  </Grid>

  return (
    <Dialog open={props.open} onClose={() => props.onClose && props.onClose()} style={{maxWidth: '100%', background: 'transparent', height: '100vh'}}
            PaperComponent={'Grid'}>
      {body}
    </Dialog>
  )
})



// WEBPACK FOOTER //
// ./app/Components/Modal.js